// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'
import Box from '@mui/material/Box'

function Sidebar ({ style, children, ...props }) {
  return (
    <Box sx={{ flex: '0 0 auto', width: 'auto', ...style }} {...props}>
      {children}
    </Box>
  )
}

export default Sidebar
